exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".listTableComp{overflow-x:auto}.list-bus-name{color:#1976d2;text-decoration:underline;padding-left:5px;font-family:'ProximaNova-Bold', sans-serif}.padding-left-sm{padding-left:5px}.MuiTableCell-root{padding:16px;padding-right:0}\n", ""]);

